import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ShopRidesService } from '../../../../services/shoprides.service';
import { HelpersService } from '../../../../services/helpers.service';
import { BroadcastService } from '../../../../services/broadcast.service';
import { Subscription } from 'rxjs';
import { MessageService } from 'primeng/api';
import { AppConfig } from '../../../../app.config';
import { ActivatedRoute, Router } from '@angular/router';

import { FullCalendarComponent } from '@fullcalendar/angular';
import { EventInput, Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeLinePlugin from '@fullcalendar/timeline';

import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-shop-rides',
  templateUrl: './shop-rides.component.html',
  styleUrls: ['./shop-rides.component.scss'],
})
export class ShopRidesComponent implements OnInit {
  @ViewChild('calendar') calendarComponent: FullCalendarComponent;
  calendarPlugins = [
    timeLinePlugin,
    dayGridPlugin,
    timeGridPlugin,
    interactionPlugin,
  ];
  headerView = 'Week, dayGridMonth';
  calendarWeekends = true;
  minTime = '00:00:00';
  maxTime = '24:00:00';
  calendarEvents: EventInput[] = [];
  event: any = [];
  public daysOfWeek = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];
  public calendarApi: Calendar;
  public calendarButtonText = {
    today: 'today',
    month: 'month',
    week: 'week',
  };
  public showRide = false;
  public selectedRideID = 0;

  public loading = true;
  public contentHeight: number = 400;
  public subscription: Subscription;

  public nowTime: any = new Date();
  public customButtons: any = {
    CreateAnEvent: {
      type: 'button',
      text: this.translate.instant('bikeshop.shop_rides.create_ride'),
      click: () => {
        this.selectedRideID = 0;
        this.showRide = true;
      },
    },
  };

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.contentHeight = window.innerHeight - 220;
  }

  constructor(
    public modalService: NgbModal,
    public shopRidesService: ShopRidesService,
    public helpersService: HelpersService,
    public broadcastService: BroadcastService,
    public messageService: MessageService,
    public translate: TranslateService,
    public appConfig: AppConfig,
    public route: ActivatedRoute,
    public router: Router,
  ) {
    this.subscription = this.broadcastService.getMessage().subscribe((data) => {
      let message = data.message;
    });
  }

  ngOnInit() {
    //This is jippo to remove the Week view for iPad with iOS9 i.e. Midstream Cycles. Had to make a work around to get the calendar to work but the week view falls over, so hiding it.
    if (
      window.navigator.userAgent.indexOf('iPad') > -1 &&
      window.navigator.userAgent.indexOf('Safari') > -1 &&
      window.navigator.userAgent.indexOf('Version/9') > -1
    ) {
      //this.headerView = 'resourceTimeGridDay, dayGridMonth';
    }

    if(this.router.url.toLowerCase().includes('/shop-rides/create-shop-ride')) {
      this.selectedRideID = 0;
      this.showRide = true;
    }
  }

  ngAfterViewInit() {
    this.calendarApi = this.calendarComponent.getApi();    
    this.addCalendarEventSource();
    this.setCalendarRefresh();
    //this.setView();
    this.calendarApi.setOption('locale', this.appConfig.getLocale());
  }

  ngAfterContentInit() {
    this.contentHeight = window.innerHeight - 220;
  }

  renderView(element, view) {
    if (this.calendarApi) {
      /*if (this.calendarApi.view.type === 'Week') {
              this.router.navigateByUrl('/clubs/events/week');
            } else {
              this.router.navigateByUrl('/clubs/events/month');
            }*/
    }
  }

  setView() {
    let view = this.route.snapshot.paramMap.get('view');
    if (view && view === 'week') {
      this.calendarApi.changeView('Week');
    } else {
      this.calendarApi.changeView('dayGridMonth');
    }
  }

  getNowDate() {
    return moment(this.nowTime).format('YYYY-MM-DDTHH:mm:ss');
  }

  addCalendarEventSource() {
    this.loading = true;
    this.calendarApi.addEventSource((event, callback) => {
      if (event.start !== this.event.start) {
        this.event = event;
        this.shopRidesService
          .getRides(
            this.helpersService.getPartnerId(),
            event.start.toISOString(),
            event.end.toISOString(),
          )
          .subscribe((rides) => {
            this.calendarApi.removeAllEvents();

            rides.forEach((ride) => {
              var today = new Date();
              var StartTime = ride.startTime;
              let startDate = moment(StartTime).toDate();
              let endDate = moment(StartTime).toDate();
              var attendees = ride.groups
                .map((x) => {
                  return x.attendees;
                })
                .reduce((a, b) => a + b, 0);
              this.calendarApi.addEvent({
                groupId: ride.id,
                id: ride.id,
                durationEditable: false,
                selectable: false,
                editable: false,
                start: startDate,
                end: endDate,
                title: ride.name,
                className: !ride.active
                  ? 'club-event-inactive'
                  : startDate < today
                    ? 'club-event-past'
                    : ride.public
                      ? 'club-event-public'
                      : 'club-event-future',
                eventTime: moment(StartTime).format('HH:mm A'),
                distance: ride.distance,
                type: ride.rideType,
                group: ride.LinkIdentifier,
                public: ride.public,
                locked: new Date(StartTime) < today,
                attendees: attendees,
              });
            });
            this.loading = false;
          });
      }
      callback([]);
    });
  }

  setCalendarRefresh() {
    setTimeout(() => {
      //dont reload when in month view as it may be too much data
      this.nowTime = new Date();
      if (
        this.calendarApi &&
        this.calendarApi.view &&
        this.calendarApi.view.type !== 'dayGridMonth'
      ) {
        this.calendarApi.refetchEvents();
        this.setCalendarRefresh();
      }
    }, 300000);
  }

  renderEvent(info) {
    if (this.calendarApi && this.calendarApi.view.type !== 'dayGridMonth') {
      if (info.event.extendedProps.eventTime) {
        info.el.firstChild.innerHTML += `<div class='fc-other'><span class='fa fa-clock-o'></span>${info.event.extendedProps.eventTime}</div>`;
      }
      if (info.event.extendedProps.distance) {
        info.el.firstChild.innerHTML += `<div class='fc-other'><span class='fa fa-road'></span>${info.event.extendedProps.distance} ${this.helpersService.getPartnerData().DefaultUnitOfMeasure == 2 ? 'mi' : 'km'}</div>`;
      }
      if (info.event.extendedProps.type) {
        info.el.firstChild.innerHTML += `<div class='fc-other'><span class='fa fa-cube'></span>${info.event.extendedProps.type}</div>`;
      }
      if (info.event.extendedProps.attendees) {
        info.el.firstChild.innerHTML += `<div class='fc-other'><span class='fa fa-group'></span><b>Attending</b> - ${info.event.extendedProps.attendees}</div>`;
      }
    } else {
      /*if (info.event.extendedProps.distance) {
              info.el.firstChild.innerHTML += `<div class='fc-other'><span class='fa fa-road'></span>${info.event.extendedProps.distance} Km</div>`;
            }*/
    }
  }

  dateClicked(event: any) {}

  scheduleClicked(event: any) {
    console.log(event);
    this.selectedRideID = event.event.id;
    this.showRide = true;
  }

  scheduleMoved(event: any) {}

  scheduleDurationChanged(event: any) {}
}
